import { z } from 'zod'

import { VALUE_TYPES } from '@/forms/VariantAxisForm/schema'

export const ParameterFormSchema = z
  .object({
    name: z.string().min(1, {
      message: 'catalog.parameters.form.name.required',
    }),
    code: z.string().min(1, {
      message: 'catalog.parameters.form.code.required',
    }),
    valueType: z.enum(VALUE_TYPES, {
      required_error: 'catalog.parameters.form.valueType.required',
    }),
    isDescriptive: z.boolean(),
    isFilterable: z.boolean(),
    isSurcharge: z.boolean(),
    values: z.array(
      z.object({
        id: z.string().optional(),
        code: z.string().min(1, {
          message: 'catalog.parameters.form.values.code.required',
        }),
        label: z.string().min(1, {
          message: 'catalog.parameters.form.values.label.required',
        }),
        percentOfBase: z.string().optional().nullable(),
        absolutePriceCzk: z.union([z.number(), z.nan()]).optional().nullable(),
      }),
    ),
  })
  .refine(
    (data) => data.isDescriptive || data.isFilterable || data.isSurcharge,
    {
      message: 'catalog.parameters.form.roles.required',
      path: ['isDescriptive'],
    },
  )

export type ParameterFormValues = z.infer<typeof ParameterFormSchema>
